import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ItemModule } from '../../../../../core/component/item/item.module';
import { WorkflowTaskItemComponent } from './workflow-task-item.component';
import { WorkflowTaskSummaryModule } from '../workflow-task-summary/workflow-task-summary.module';
import {WorkflowTaskHumanSaveModule} from '../../../impl/page/workflow-task-human-save/workflow-task-human-save.module';
import {
    EmailSentViewModule
} from '../../../../../communication/email/api/component/email-sent-view/email-sent-view.module';
import {ActionButtonModule} from "../../../../../core/component/action-button/action-button.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        ItemModule,
        WorkflowTaskSummaryModule,
        WorkflowTaskHumanSaveModule,
        EmailSentViewModule,
        ActionButtonModule,
    ],
    declarations: [
        WorkflowTaskItemComponent,
    ],
    exports: [
        WorkflowTaskItemComponent
    ],
})
export class WorkflowTaskItemModule {
}